import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { authenticatedFetch } from "../../../network/api";
import SettingsAppointmentTypes from "../../settings/components/settingsAppointmentTypes";
import "./onboardingSteps.css";

const VisitReason = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  // Get user data from Redux store
  const userData = useSelector((state) => state.attorneyData.attorneyData);
  const firmData = useSelector((state) => state.firm.details);

  const handleDone = async () => {
    if (!userData?.user_id) {
      setError("User ID not found. Please try again.");
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await authenticatedFetch("/api/attorney/webapp/updateOnboardingStage", {
        method: "POST",
        body: JSON.stringify({
          user_id: userData.user_id,
          onboarding_stage: userData.admin ? 6 : 5, // Stage 5 for admin, Stage 4 for attorney
        }),
      });

      const data = await response.json();
      
      if (response.ok) {
        setSuccess(true);
        // Optionally navigate to the next step or dashboard
        setTimeout(() => {
          navigate(`/attorney/${userData.user_id}/home`)
        }, 2000);
      } else {
        setError(data.error || "Failed to update onboarding stage");
      }
    } catch (err) {
      console.error("Error updating onboarding stage:", err);
      setError("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="onboarding-step-container">
      <main className="onboarding-step-main">
        <div className="onboarding-step-main-left">
          {/* Back button */}
          <div className="onboarding-step-back-button">
            <button
              onClick={() => navigate(-1)}
              className="onboarding-step-back-btn"
            >
              ← Back
            </button>
          </div>
          
          <h1 className="onboarding-step-title">
            Set up your visit reasons
          </h1>
          
          <div className="onboarding-step-checklist-section">
            <SettingsAppointmentTypes />
            
            {/* Done button section */}
            <div className="onboarding-step-done-section">
              <div>
                {error && (
                  <p className="onboarding-step-error">
                    {error}
                  </p>
                )}
                {success && (
                  <p className="onboarding-step-success">
                    Onboarding status updated successfully!
                  </p>
                )}
              </div>
              
              <button
                onClick={handleDone}
                disabled={loading || !userData?.user_id}
                className={`onboarding-step-done-btn ${loading ? 'onboarding-step-loading' : ''}`}
              >
                {loading ? "Updating..." : "Done"}
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default VisitReason;
